import React from 'react';
import Navbar from '../../components/navbar';
import PolicyComponent from './Policy';
const Product = () => {
  return (
    <React.Fragment>
      <Navbar isBlack={true} />
      <PolicyComponent />
    </React.Fragment>
  );
};

export default Product;
